export const agreementXml = (state) => state.industryAgreement.industryAgreement.industryAgreementXml
export const isLoading = (state) => state.industryAgreement.isLoading
export const isSuccess = (state) => state.industryAgreement.isSuccess
export const agreements = (state) => state.industryAgreement
export const agreement = (state) => state.industryAgreement.industryAgreement.data
export const isLoadingIndustryAgreement = (state) => state.industryAgreement.industryAgreement.isLoading
export const isSuccessIndustryAgreement = (state) => state.industryAgreement.industryAgreement.isSuccess
